import { Switcher, SwitchersParent } from "./styles"
import { FC, useEffect, useState } from "react";

type SwitchersProps = {
  type: string;
  setType: (type: string) => void;
}

export const Switchers: FC<SwitchersProps> = ({
  type,
  setType
}) => {

  const [ translate, setTranslate ] = useState<number>(0);

  useEffect(() => {
    if (type === 'phone') {
      setTranslate(1);
    } else {
      setTranslate(0);
    }
  }, [type])

  return (
    <SwitchersParent
      style={{"--translate": translate} as React.CSSProperties}
    >
      <i></i>
      <Switcher onClick={() => setType('email')}>Почта</Switcher>
      <Switcher onClick={() => setType('phone')}>Телефон</Switcher>
    </SwitchersParent>
  )
}